import React from 'react';
import { IMaskInput } from 'react-imask';

const CNPJMask = React.forwardRef(function CNPJMask(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="00.000.000/0000-00"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value: value.replace(/[^0-9]/g, '') } })}
      overwrite
    />
  );
});

export default CNPJMask;
